/**
 * Resolve the BiQ answer `chat_id` for a user question in the same turn.
 * Used to log share/feedback against the monitoring row for that Q&A pair.
 */
export function findBiqChatIdForUserMessage(messages, userMessageId) {
  const idx = messages.findIndex((m) => m.id === userMessageId);
  if (idx === -1) return null;
  for (let i = idx + 1; i < messages.length; i++) {
    if (messages[i].type === 'user') return null;
    if (messages[i].type === 'biq' && messages[i].chatId) {
      return messages[i].chatId;
    }
  }
  return null;
}
